<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo auth-logo">
        <sattva-logo />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Sattva Human Portal 👋
          </b-card-title>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Email" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="email"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="xxxxxx@sattvahuman.com"
                  />
                  <small id="uname" class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <!--    <b-link :to="{name:'auth-forgot-password'}">
                    <small>Forgot Password?</small>
                  </b-link>-->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <!-- <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append> -->
                  </b-input-group>
                  <small id="pwd" class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Sign in
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import SattvaLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import AuthService from '@/services/auth-service';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import userService from "@/services/user-service";
import { updateAbilities } from "@/libs/acl/ability";
import { ensureFcmReady } from '@/utils/fcm-push'
import { resetSessionExpiryHandled } from '@/utils/session-expiry'

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    SattvaLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "",
      //email: '',
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      //URL: process.env.VUE_APP_URL,
      // validation rules
      required,
      email,
      //notifications: [],
    };
  },
  computed: {
    
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
    
  },
  
  methods: {
    login() {
      let bodyContent = {
                email: this.email,
                password: this.password
           };
      AuthService.login(bodyContent).then(res =>{
        ////console.log(res.data.data.message)
        if ( res == undefined ) {
          document.getElementById('pwd').innerHTML = 'Error!! Please Contact Administrator.'
          return
        }
        if(res && res.status === "OK" ) {
            const userData = res.data;

            // Persist session first, then hydrate CASL, then navigate.
            // Vertical nav items must use static action/resource (see
            // navigation/vertical/*.js) — visibility is evaluated at render via
            // $can against this updated ability instance.
            useJwt.setToken(res.data.accessToken)
            useJwt.setRefreshToken(res.data.refreshToken)
            localStorage.setItem('userData', JSON.stringify(userData))
            const expiresIn = Math.floor(Date.now() / 1000) + parseInt((userData.expireIn))
            localStorage.setItem('expireIn', JSON.stringify(expiresIn))
            localStorage.setItem('emp_id', JSON.stringify(userData.emp_id))

            resetSessionExpiryHandled()
            this.updateAbilities(userData.abilities)

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `Welcome ${userData.first_name || userData.username}`,
                icon: "CoffeeIcon",
                variant: "success",
                text: `You have successfully logged in as ${userData.roles[0]}. Now you can start to explore!`,
              },
            });

            // Prefetch users list in parallel; do not block landing navigation.
            userService.getAllUsersDdActiveInactive().then(usersRes => {
              localStorage.setItem('allusers', JSON.stringify(usersRes.data))
            })

            // Global FCM: permission + device token for all modules (tasks,
            // attendance, candidates/jobs). Not tied to a feature page.
            ensureFcmReady(this)

            // Wait a tick so ability watchers / $can consumers see new rules
            // before the authenticated layout + dashboard mount.
            this.$nextTick(() => {
              const lastPageUrl = window.sessionStorage.getItem('lastPage');
              if (lastPageUrl && lastPageUrl !== '/login') {
                this.$router.push(lastPageUrl);
              } else {
                this.$router.replace(getHomeRouteForLoggedInUser(res.data.roles[0]))
              }
            })
          }
          else if ( res.status === 400 && res.data.mesage === "Invalid Password!") 
          {
            document.getElementById('pwd').innerHTML = res.data.message
          }
          else if ( res.status === 400 && res.data.mesage === "User Not Found.") 
          {
            document.getElementById('uname').innerHTML = res.data.message
          }
          
          else {
            document.getElementById('pwd').innerHTML = 'Invalid username or password'
          }
      })
     
    },
    updateAbilities(abilities) {
      if (abilities && Array.isArray(abilities)) {
          updateAbilities(abilities);
      } else {
          console.error("Invalid abilities format:", abilities);
          // Optionally set a default or restricted set of abilities
          this.$ability.update([{ action: 'read', subject: 'all' }]);
      }
    }
  },
  mounted () {
    ////console.log('Firebase cloud messaging object', this.$messaging)
  },
  created () {
    //console.log('Login Page base url', process.env.VUE_APP_URL)
    //console.log('Login Page base url from node', process.env.NODE_ENV)
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.auth-wrapper.auth-v2 .brand-logo.auth-logo {
  svg {
    height: 48px;
    width: 72px;
  }
}
</style>
